import { PlatformType } from '@okletsplay/core';

export const TOURNAMENT_DRAW_RESULTS_ENABLED_PLATFORM_TYPES = [
  PlatformType.Lichess,
  PlatformType.Lidraughts,
  PlatformType.Papergames,
  PlatformType.EvIo,
];
